module.exports = __webpack_public_path__ + "static/media/feature-2.d9af8b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/landing/images/feature-2.png
// module id = 341
// module chunks = 0